import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"
import { EditIcon } from "../../../ui/icons/edit"
import { M024Details } from "./dataService/dto"
import { setM024SelectedId } from "./slice"

export function ListM024Customer() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)

    const onEditHandle = (m024Details: M024Details) => {
        dispatch(setM024SelectedId(m024Details.id))
        navigate('/editM024')
    }

    const m024 = {
        id: '1',
        data: '02/02/2022'
    }

    if (sessionState.selected.customerId) {
        return (
            <div className="mt-4">
                <table id="list-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}>Revisione M024</th>
                            <th>Seleziona</th>
                            <th>Data</th>
                            <th>Stato</th>
                            <th>M029</th>
                            <th>Tipologia</th>
                            <th style={{ borderTopRightRadius: '8px' }}>Stampa</th>
                        </tr>
                    </thead>
                    <tbody>
                        <td>test</td>
                        <td>
                            <div style={{ display: 'flex', gap: '6px' }}>
                                <button onClick={() => onEditHandle(m024)}>
                                    <EditIcon color="orange" size={20} />
                                </button>
                            </div>
                        </td>

                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <Banner
            type="error"
            visible={!sessionState.selected.customerId}
            label={"Devi prima selezionare un cliente per accedere all'area"}
            closeAction={function (): void {
                alert("Devi prima selezionare un cliente per accedere all'area")
            }}
        />
    )

}